import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { BoundingBox, MiddlePoint } from "@/types/stage";


export default /*@__PURE__*/_defineComponent({
  __name: 'AzimuthArrow',
  props: {
    facadeDirection: {},
    boundingBox: {},
    middlePoint: {}
  },
  setup(__props: any) {

const props = __props;

const arrowHeight = computed(() => {
  if (props.facadeDirection === null) {
    return null;
  }
  if (props.facadeDirection === 90 || props.facadeDirection === 270) {
    return props.boundingBox?.width;
  }

  return props.boundingBox?.height;
});

const tailConfig = computed(() => ({
  points: [0, 0, 100, 0, 50, 0, 50, 20],
  stroke: "red",
  strokeWidth: 5,
  closed: false,
}));

const triangleConfig = computed(() => ({
  points: [0, 0, 50, 50, 100, 0],
  fill: "red",
  stroke: "red",
  strokeWidth: 2,
  closed: true,
  x: 0, // относительно группы
  y: arrowHeight.value || 50, // расстояние от хвоста
}));

const groupConfig = computed(() => ({
  x: props.middlePoint?.x,
  y: props.middlePoint ? props.middlePoint.y + 10 : null,
  width: 100,
  rotation: (props.facadeDirection ? props.facadeDirection : 0) + 180,
  offsetX: 50,
  offsetY: arrowHeight.value ? arrowHeight.value / 2 + 10 : null,
}));

const showAzimuthArrow = computed(
  () => props.middlePoint && props.boundingBox && props.facadeDirection !== null
);

return (_ctx: any,_cache: any) => {
  const _component_v_line = _resolveComponent("v-line")!
  const _component_v_group = _resolveComponent("v-group")!

  return (showAzimuthArrow.value)
    ? (_openBlock(), _createBlock(_component_v_group, {
        key: 0,
        config: groupConfig.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_line, { config: tailConfig.value }, null, 8, ["config"]),
          _createVNode(_component_v_line, { config: triangleConfig.value }, null, 8, ["config"])
        ]),
        _: 1
      }, 8, ["config"]))
    : _createCommentVNode("", true)
}
}

})